
    <mat-card-header  class="badge-container"  *ngFor="let data of companyList; let i=index;">
        <div mat-card-avatar class="company-logo"></div>
        <mat-card-title class="badge-title">{{data}}</mat-card-title>
    </mat-card-header>